import React from 'react';
import { useI18n } from '../../i18n/I18nContext';
import { agoText, describeInstant, formatPosition } from './time';
import './Student360.css';

const REASON_KEY = {
  IN_PROGRESS: 'inProgress',
  NEXT: 'next',
  FIRST: 'first',
  FINISHED: 'finished',
};

/**
 * Where the student is in a course: "4 / 6", the lesson title and why it is the one
 * (in progress, up next, not started, finished) with when it was last touched. `lesson` is the
 * contract's CurrentLesson; null (a course without published lessons) renders an em dash.
 * `compact` is the table cell: the position over the title. Otherwise one sentence with the
 * paused position of a video that was left half way.
 */
function LessonLine({ lesson, now, compact = false }) {
  const { t } = useI18n();
  if (!lesson) return <span className="s360-muted">—</span>;

  const reason = t(`student360.lesson.reason.${REASON_KEY[lesson.reason] || 'inProgress'}`);
  const touched = lesson.touchedAt ? agoText(t, describeInstant(lesson.touchedAt, now)) : '';
  const meta = touched ? `${reason} · ${touched}` : reason;

  if (compact) {
    return (
      <div className="s360-lesson is-compact">
        <span className="s360-lesson-title" title={lesson.title}>
          <strong>{t('student360.lesson.short', { index: lesson.index, total: lesson.total })}</strong>
          {' '}
          {lesson.title}
        </span>
        <span className="s360-lesson-meta">{meta}</span>
      </div>
    );
  }

  return (
    <div className="s360-lesson">
      <span className="s360-lesson-pos">{t('student360.lesson.position', { index: lesson.index, total: lesson.total })}</span>
      <span className="s360-lesson-title" title={lesson.title}>{lesson.title}</span>
      <span className="s360-lesson-meta">
        {meta}
        {lesson.reason === 'IN_PROGRESS' && lesson.position > 0
          ? ` · ${t('student360.lesson.pausedAt', { time: formatPosition(lesson.position) })}`
          : ''}
      </span>
    </div>
  );
}

export default LessonLine;
